import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useBreadcrumbs, useUser } from '../hooks';
import { Header, Icon, Table } from 'react-frontier';
import { Contract } from '../SiteClasses';
import UserAccess from '../UserAccess';
import API from '../API';

var ContractsList = ()=>{
	var { setTitle } = useBreadcrumbs();
	var { hasAccess } = useUser();
	var [contracts, setContracts] = useState<Contract[]>(null);
	var [loadError, setLoadError] = useState<string>(null);

	useEffect(()=>{
		setTitle('Contratos');
		if(!hasAccess(UserAccess.CONTRACTS.VIEW_CONTRACTS)) return;
		get();
	}, []);

	if(!hasAccess(UserAccess.CONTRACTS.VIEW_CONTRACTS)) return <Header text='Sin acceso' subtext='No tienes permiso para ver esta sección.' />;

	var get = ()=>{
		API.getContracts().then(res=>{
			if(res.error) return setLoadError(res.message);
			setContracts(res.data);
		}).catch(()=>{
			setLoadError('Hubo un error al cargar los contratos.');
		});
	};

	if(loadError) return <Header text='Error' subtext={loadError} />;
	if(!contracts) return <Header loading text='Cargando...' />;

	return (
		<Table
			title='Contratos'
			selectable
			headers={['ID', 'Titulo']}
			style={{ margin: 'auto', marginTop: 20, maxWidth: 400 }}
			collapsingIndexes={[0, 1]}
			emptyText='No hay contratos registrados.'
		>
			{contracts.map(c=>(
				<Table.Row
					compact
					key={c.contract_id}
					as={Link}
					to={`/contract/${c.contract_id}`}
					data={[
						c.contract_id,
						c.contract_title || <Icon name='minus' />,
					]}
				/>
			))}
		</Table>
	);
};

export default ContractsList;
